import React, { useState } from "react"
import Button from "@kit/design/button"
import PlanComparison from "app/shared/components/plan-comparison"
import usePlanComparison from "hooks/use-plan-comparison"
import analytics from "utils/analytics"

const TEXT = "Upgrade"

export function FreePlanUpgradeButton({
  userInfo = {},
  freeUpgradeExperiment
}) {
  const [open, setOpen] = useState(false)
  const canUsePlanComparison = usePlanComparison(open)

  function handleClick() {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        name: "free_header_upgrade_button",
        location: "primary_nav",
        text: TEXT
      },
      { transport: "beacon" }
    )

    if (freeUpgradeExperiment) {
      window.location.href = "/upgrade"
    } else {
      setOpen(true)
    }
  }

  function trackCelebration() {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        name: "upgraded_from_free_header",
        location: "primary_nav"
      },
      { transport: "beacon" }
    )

    window.location.reload()
  }

  if (!userInfo.free || userInfo.trialing) {
    return null
  }

  return (
    <>
      <Button is="primary" size="sm" onClick={handleClick}>
        {TEXT}
      </Button>

      {open && canUsePlanComparison && (
        <PlanComparison
          title="Upgrade to access new features"
          description="Upgrade to remove Kit branding and unlock access to powerful growth features like unlimited Advanced Visual Automations, Rules, Integrations, and more. Choose a plan below."
          onClose={() => setOpen(false)}
          serviceLevels={["creator", "creator_pro"]}
          afterCelebration={trackCelebration}
        />
      )}
    </>
  )
}
